var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.059,
    height: 52.578,
    viewBox: "0 0 49.059 52.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15543",
    "data-name": "Path 15543",
    d: "M33.879-25.6,47.748-10.35q2.346,2.622,2.346,4.416T47.438-1.725Q44.781.69,42.952.69T38.709-2.07L25.6-17.112,12.489-2.07Q10.005.69,8.245.69T3.76-1.76Q1.035-4.209,1.035-5.934T3.45-10.35L17.319-25.6,3.45-40.848Q1.035-43.4,1.035-45.195t2.691-4.243q2.691-2.449,4.519-2.449t4.243,2.76L25.6-34.086l13.11-15.042q2.484-2.76,4.243-2.76T47.4-49.473q2.691,2.415,2.691,4.278t-2.346,4.347Z",
    transform: "translate(-1.035 51.888)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.92140efeecb6b2801adccccd48835df4.svg";
export { ForwardRef as ReactComponent };